import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Component, OnInit, Output, EventEmitter, Inject, OnDestroy } from '@angular/core';
import { TipusMatriculaFilter } from 'app/sections/ciutat/tipus-matricules/models/tipus-matricula-filter';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-tipus-matricules-filter',
  templateUrl: './tipus-matricules-filter.component.html',
  styleUrls: ['./tipus-matricules-filter.component.scss']
})
export class TipusMatriculesFilterComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  filter: TipusMatriculaFilter;

  @Output() notify: EventEmitter<TipusMatriculaFilter> = new EventEmitter<TipusMatriculaFilter>();

  constructor(
    public thisDialogRef: MatDialogRef<TipusMatriculesFilterComponent>,
    private i18n: I18n,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
    this.filter = data.filter;
  }

  ngOnInit() {
    this.subscription = Observable.fromEvent(document, 'keypress').subscribe((e: KeyboardEvent ) => {
      if (e.key === 'Enter') {
        this.apply();
      }
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  reset() {
    this.filter.clear();
    this.apply();
  }

  apply() {
    this.filter.updated();
    this.notify.emit(this.filter);
    this.thisDialogRef.close();
  }

  dismiss() {
    this.thisDialogRef.close();
  }
}
